import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, LOGO } from "../mock";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-md shadow-[0_4px_24px_rgba(108,92,231,0.08)] py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center justify-between">
        <a
          href="#home"
          onClick={(e) => handleNav(e, "#home")}
          className="flex items-center group"
        >
          <img
            src={LOGO.full}
            alt="Sago Industries"
            className="h-11 w-auto transition-transform group-hover:scale-105"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNav(e, link.href)}
              className="relative text-[15px] font-medium text-[var(--ink)] transition-colors hover:text-[var(--brand)] after:absolute after:-bottom-1.5 after:left-0 after:h-0.5 after:w-0 after:bg-[var(--brand)] after:transition-all after:duration-300 hover:after:w-full"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          onClick={(e) => handleNav(e, "#contact")}
          className="hidden lg:inline-flex items-center rounded-full bg-[var(--accent)] px-6 py-2.5 text-sm font-bold text-[var(--ink)] shadow-md transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl"
        >
          Get In Touch
        </a>

        <button
          className="lg:hidden text-[var(--ink)]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden mt-3 mx-4 rounded-2xl bg-white p-5 shadow-xl border border-gray-100">
          <nav className="flex flex-col gap-2">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNav(e, link.href)}
                className="rounded-lg px-3 py-2.5 font-medium text-[var(--ink)] transition-colors hover:bg-[var(--brand)]/5 hover:text-[var(--brand)]"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={(e) => handleNav(e, "#contact")}
              className="mt-2 rounded-full bg-[var(--accent)] px-6 py-3 text-center text-sm font-bold text-[var(--ink)]"
            >
              Get In Touch
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
